import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=877bde04&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=877bde04&prod&scoped=true&lang=css"
import style1 from "./UserIcon.vue?vue&type=style&index=1&id=877bde04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877bde04",
  null
  
)

export default component.exports